import React              from 'react';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';

import './activity-indicator.scss';

export default class ActivityIndicator extends React.Component {
    render() {
        const { visible } = this.props;

        return (
            <CSSTransitionGroup className="activity-indicator-container"
                transitionName="activity-indicator-animate"
                transitionAppear={ false }
                transitionAppearTimeout={ 800 }
                transitionEnterTimeout={ 800 }
                transitionLeaveTimeout={ 400 }>
                { visible &&
                    <div className="activity-indicator" ref={ this.beginAnimation } >
                        <svg className="spinner" viewBox="0 0 66 66">
                            <g>
                                <circle className="path" cx="33" cy="33" r="30"></circle>
                            </g>
                        </svg>
                        <span />
                    </div>
                }
            </CSSTransitionGroup>
        );
    }

    beginAnimation = ( element ) => {
        if ( element ) {

            const svg = element.childNodes[ 0 ];
            const group = svg.childNodes[ 0 ];
            const circle = group.childNodes[ 0 ];

            const now = window.performance ? window.performance.now() : new Date().valueOf();
            const duration = 1400.00;
            const offset = 187.00;

            const animate = () => {
                const percent = ( ( ( window.performance ? window.performance.now() : new Date().valueOf() - now ) / duration ) % 1 ) ;

                const groupRoteate = percent * 270;
                group.setAttribute( 'transform', 'rotate(' + groupRoteate.toString() + ', 33, 33)' );

                const strokeDashoffset = ( Math.abs( percent - .5 ) / .5 ) * ( offset - ( offset / 4 ) ) + ( offset / 4 );
                circle.style.strokeDashoffset = strokeDashoffset;

                const strokeOpacity = percent;
                circle.style.opacity = strokeOpacity;

                const strokeRotate = percent * 450;
                circle.setAttribute( 'transform', 'rotate(' + strokeRotate.toString() + ', 33, 33)' );

                window.requestAnimationFrame( animate );
            };

            if ( typeof window.requestAnimationFrame === 'function' ) {
                animate();
            }
        }
    };
}

export const activityIndicatorHtml = (
    '<style>' +
        'body { background-color: #f5f5f5; } ' +
        '.branded { ' +
            'color: #0a90d9; } ' +
        '.branded-bg { ' +
            'background-color: #0a90d9; } ' +
        '.activity-indicator-container { ' +
            'display: -webkit-box; ' +
            'display: -webkit-flex; ' +
            'display: -ms-flexbox; ' +
            'display: flex; ' +
            '-webkit-box-pack: center; ' +
            '-webkit-justify-content: center; ' +
                '-ms-flex-pack: center; ' +
                    'justify-content: center; ' +
            'padding: 15rem 0 0 0; } ' +
      '.activity-indicator .spinner { ' +
        '-webkit-animation: rotator 1.4s linear infinite; ' +
                'animation: rotator 1.4s linear infinite; ' +
        'height: 10em; ' +
        'width: 10em; ' +
        'z-index: 1; } ' +
        '.activity-indicator .spinner .path { ' +
          'fill: none; ' +
          'stroke-width: 4; ' +
          'stroke-linecap: round; ' +
          'stroke-dasharray: 187; ' +
          'stroke-dashoffset: 0; ' +
          '-webkit-transform-origin: center; ' +
                  'transform-origin: center; ' +
          '-webkit-animation: dash 1.4s ease-in-out infinite, colors 5.6s ease-in-out infinite; ' +
                  'animation: dash 1.4s ease-in-out infinite, colors 5.6s ease-in-out infinite; } ' +
    '@-webkit-keyframes rotator { ' +
      '0% { ' +
        '-webkit-transform: rotate(0deg); ' +
                'transform: rotate(0deg); } ' +
      '100% { ' +
        '-webkit-transform: rotate(270deg); ' +
                'transform: rotate(270deg); } } ' +
    '@keyframes rotator { ' +
      '0% { ' +
        '-webkit-transform: rotate(0deg); ' +
                'transform: rotate(0deg); } ' +
      '100% { ' +
        '-webkit-transform: rotate(270deg); ' +
                'transform: rotate(270deg); } } ' +
    '@-webkit-keyframes colors { ' +
      '0% { ' +
        'stroke: #0a90d9; } ' +
      '100% { ' +
        'stroke: #b3e2fc; } } ' +
    '@keyframes colors { ' +
      '0% { ' +
        'stroke: #0a90d9; } ' +
      '100% { ' +
        'stroke: #b3e2fc; } } ' +
    '@-webkit-keyframes dash { ' +
      '0% { ' +
        'stroke-dashoffset: 187; } ' +
      '50% { ' +
        'stroke-dashoffset: 46.75; ' +
        '-webkit-transform: rotate(135deg); ' +
                'transform: rotate(135deg); } ' +
      '100% { ' +
        'stroke-dashoffset: 187; ' +
        '-webkit-transform: rotate(450deg); ' +
                'transform: rotate(450deg); } } ' +
    '@keyframes dash { ' +
      '0% { ' +
        'stroke-dashoffset: 187; } ' +
      '50% { ' +
        'stroke-dashoffset: 46.75; ' +
        '-webkit-transform: rotate(135deg); ' +
                'transform: rotate(135deg); } ' +
      '100% { ' +
        'stroke-dashoffset: 187; ' +
        '-webkit-transform: rotate(450deg); ' +
                'transform: rotate(450deg); } ' +
    '} ' +
    '</style>' +
    '<div class="activity-indicator-container">' +
        '<div class="activity-indicator">' +
            '<svg class="spinner" viewBox="0 0 66 66">' +
                '<circle class="path" cx="33" cy="33" r="30"></circle>' +
            '</svg>' +
        '</div>' +
    '</div>' );